<template>
  <!--<div class="Exercise">
      &lt;!&ndash; 头部开始 &ndash;&gt;
      <div class="header">
        <div class="width">
          <div class="header-left">
            <div class="user-img"></div>
            <p class="user-name">asdsadsadsa</p>
          </div>
          <div class="header-mid">
            <span class="time-icon"></span>
            <span class="time-number">19
              <i>minutes left</i>
            </span>
            <span class="time-number"></span>
          </div>
          <div class="header-right">
            <ul>
              <li class="header-control"></li>
              <li class="header-tip">
                <p>放弃模考</p>
              </li>
              <li class="header-btn">
                <button>交卷</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      &lt;!&ndash; 头部结束 &ndash;&gt;
      <div class="title width">
        <h1>Sample Academic Reading Multiple Choice (one answer)</h1>
      </div>
    </div>-->
  <div class="layout">
    <audio ref="audio" hidden controls autoplay="autoplay" :src="data[page - 1].audioUrl"
      v-if="data.length && title === 1"></audio>
    <div class="layout-ceiling" style="position: fixed;z-index: 999;width: 100%;top: 0;left: 0;">
      <div class="layout-user"
        v-if="$route.params.testNum !== `scripture` && !$route.params.sectionNum && $route.params.testNum !== `scripture1`">
        <img src="/static/img/logo111.png" style="height: 37px;width: 117px;margin-left: 40px;cursor: pointer"
          @click="exit" />
        <p style="margin-left: 30px">剑{{ $route.params.camNum }}-T{{ $route.params.testNum }}</p>
        <p v-if="title === 1">听力</p>
        <p v-else-if="title === 3">阅读</p>
        <p v-else>写作</p>
      </div>
      <div class="layout-user" v-else>
        <img src="/static/img/logo111.png" style="height: 37px;width: 117px;margin-left: 40px;cursor: pointer"
          @click="exit" />
        <p style="margin-left: 30px" v-if="~~$route.params.sectionNum">
          剑{{ $route.params.camNum }}-T{{ $route.params.testNum }}-S{{ $route.params.sectionNum }}</p>
      </div>
      <div class="layout-time" :style="{ marginRight: isPhone ? '10px' : '' }"
        v-if="!(this.$route.params.testNum === `scripture` || this.$route.params.testNum === `scripture1` || this.$route.params.sectionNum)">
        <span>
          <Icon type="ios-alarm-outline"></Icon>
        </span>
        <span>{{ m + ':' + s }}
          <!--<i>minutes left</i>-->
        </span>
      </div>
      <div class="layout-ceiling-main" style="display: flex;">
        <i-button type="primary" style="margin-right: 20px;"
          v-if="this.$route.params.testNum === `scripture` || this.$route.params.testNum === `scripture1` || this.$route.params.sectionNum"
          @click="seeAnswer()">答案</i-button>
        <i-button type="primary" @click="playAudio(false)" style="margin-right: 20px;" v-if="title === 1 && isPlay">暂停
        </i-button>
        <i-button type="primary" @click="playAudio(true)" style="margin-right: 20px;" v-if="title === 1 && !isPlay">播放
        </i-button>
        <i-button type="primary" @click="custom"
          v-if="$route.params.testNum !== `scripture` && $route.params.testNum !== `scripture1` && title !== 4 && !$route.params.sectionNum"
          style="margin-right: 20px;">下一单元</i-button>
        <i-button type="primary" @click="finish" v-if="$route.params.testNum !== `scripture` && title === 4"
          style="margin-right: 20px;">完成</i-button>
        <i-button type="primary" @click="back"
          v-if="this.$route.params.testNum === `scripture` || this.$route.params.testNum === `scripture1` || this.$route.params.sectionNum"
          style="margin-right: 20px;">返回</i-button>
        <i-button type="primary" @click="exit">退出</i-button>
        <!--<i-button type="primary" @click="exit" v-if="">完成</i-button>-->
      </div>
    </div>
    <div class="header-container">
      <div class="layout-header"
        v-if="title !== 4 && $route.params.testNum !== `scripture1` && $route.params.testNum !== `scripture` && !$route.params.sectionNum"
        style="position: fixed;bottom: 0;z-index: 999;width: 100%">
        <h1 :style="{ textAlign: isPhone ? 'center' : '' }">{{ title === 1 ? 'Section' : 'Passage' }} {{ page }}</h1>
        <ul class="ivu-page" v-if="!isPhone">
          <li :title="index"
            :class="{ click: selectItemIndex === index, active: item !== undefined && item !== '' ? true : false }"
            :style="{ margin: isPhone ? '6px' : '' }" @click="goQuestion(index)" class="ivu-page-item"
            v-for="(item, index) in value " :key="index" v-scroll-to="{
              el: '#element' + (index + 1),
              container: title === 3 ? '.reading-question' : 'body',
              duration: 500,
              easing: 'linear',
              offset: -200,
              force: true,
              cancelable: true,
              x: false,
              y: true
            }"><a class="active-a">{{ index + 1 }}</a></li>
        </ul>
        <div class="btn-div" :class="{ isPhoneDiv: isPhone }">
          <i-button v-show="isPhone" type="primary" style="margin-right: 15px;" @click="changePage(false)"
            v-if="page !== 1">上一页</i-button>
          <i-button v-show="isPhone" type="primary" style="margin-right: 15px;" @click="changePage(true)"
            :style="{ visibility: page === pageLen ? 'hidden' : '' }">下一页</i-button>
        </div>
      </div>
    </div>
    <div class="hearing-box" style="margin-top: 52px">
      <Hearing v-if="title === 1" :question="question" :data="data" :contentFilters="contentFilters" :page="page"
        :isPhone="isPhone" :value="value" :inputBlue="inputBlue" :checkboxChange="checkboxChange"
        :checkboxItem="checkboxItem" :isLen="isLen" :showLength="showLength" :selectItemIndex="selectItemIndex"
        :answer="answer" ref="Hearing" />
      <Reading v-if="title === 3" :question="question" :data="data" :contentFilters="contentFilters" :page="page"
        :isPhone="isPhone" :value="value" :inputBlue="inputBlue" :checkboxChange="checkboxChange"
        :checkboxItem="checkboxItem" :isLen="isLen" :showLength="showLength" ref="Reading" />
      <writing v-if="title === 4" :isPhone="isPhone" />
    </div>

  </div>
</template>

<script>

import ajax from './../../api/ajax'
import { scrollAnimation } from '../../../static/js/scroll'
import Hearing from './children/Hearing'
import Reading from './children/Reading'
import Writing from './children/Writing'
export default {
  name: "Exercise",
  data() {
    return {
      value6: '',
      url: "https://winielts.com",
      question: [],
      answer: {
        hearing: [],
        reading: [],
        writing: []
      },
      value: [],
      newValue: [{
        answer: "",
        serial: ""
      }],   //回答数据
      page: 1,
      audioUrl: '',
      audio: false,
      m: 0,
      s: 0,
      isPhone: false,
      data: [],
      selectModels: '',
      title: 1,  //1为听力 3为阅读
      selectDisabled: [],
      selectLength: [],
      checkboxItem: [],
      isLen: [],
      pageLen: 0,
      i: 0,
      selectItemIndex: 0,
      isPlay: true
    }
  },

  components: {
    Reading,
    Hearing,
    Writing
  },
  computed: {

  },
  mounted() {
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //检测是否移动端
      this.isPhone = true
    }
    this.getData()
    //
    this.$route.params.sectionNum = ~~this.$route.params.sectionNum
    console.log(this.$route.params);
    if (!~~this.$route.params.sectionNum) {
      this.countDown()
    }
  },
  methods: {
    seeAnswer() {
      if (this.title === 1) {
        this.$refs.Hearing.seeAnswer();
      } else {
        this.$refs.Reading.seeAnswer();
      }

    },
    exit() {
      // console.log();
      this.$Modal.confirm({
        title: '返回',
        content: '<p>即将返回首页，是否确认？</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          window.onbeforeunload = null
          this.$router.push({ name: 'home' })
        },
      });
    },
    back() {
      this.$Modal.confirm({
        title: '返回',
        content: '<p>即将返回，是否确认？</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$router.go(-1)
          // this.$router.push({ name: 'listen', params: {camNum:this.$route.params.camNum,testNum:this.$route.params.testNum,sectionNum:this.$route.params.sectionNum}});
        },
      });
    },
    goQuestion(idx) {   //点击索引跳转
      this.selectItemIndex = idx
      let currentNum = ''
      let item2Arr = []
      let divArr = []
      let top = 0
      this.data.forEach((item, i) => {
        item.themeDomainList.forEach(item1 => {
          item1.trunkList.forEach(item2 => {
            if (idx + 1 == item2.serial) {
              this.page = i + 1
              this.audio = false
              this.localData()
              const currentY = document.documentElement.scrollTop || document.body.scrollTop
              scrollAnimation(currentY, 0)
            }
          })
        })
      })
    },
    instance(type) {
      const title = '时间结束';
      const content = '<p>即将进入下一单元</p>';
      this.answerCom()
      if (this.title === 1) {
        this.$Modal.info({
          title: title,
          content: content,
          onOk: () => {
            this.answer.hearing = this.value
            this.value = []
            this.title = 3
            this.page = 1
            this.m = 59,
              this.s = 59,
              this.getData();
            this.$Message.info('阅读题开始');
            console.log(this.answer);
          },
        });
      } else if (this.title === 3) {
        this.$Modal.info({
          title: title,
          content: content,
          onOk: () => {
            this.answer.reading = this.value
            this.$Message.info('写作题开始');
            this.title = 4
            this.value = []
            this.page = 1
            this.m = 29
            this.s = 59
            console.log(this.answer);
          },
        });
      } else {
        this.$Modal.confirm({
          title: '完成',
          content: '时间已结束，是否去核对答案',
          okText: '是',
          cancelText: '否',
          onOk: () => {
            this.$router.push({ name: 'answer', params: { answer: this.answer, camNum: this.$route.camNum, testNum: this.$route.testNum } });
          },
        });
      }

      this.countDown()
    },
    showLength(v, i) {   //多选题
      let arr = v.split(/,|，/)
      this.selectLength = arr;
      this.i = i
    },
    checkboxChange(i) {
      console.log(i);
      this.checkboxItem[this.i] = i
      if (i.length === this.selectLength.length) {
        this.selectLength.forEach((item, index) => {
          this.value[item - 1] = i
        })
        this.isLen[this.i] = true
      } else {
        this.selectLength.forEach(item => {
          this.value[item - 1] = ''
        })
        this.isLen[this.i] = false
      }
      console.log();
    },
    async getData() {
      let data = []
      if (window.__PRERENDER_INJECTED) {
        throw "PrerenderSPAPlugin render";
      }
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', 'Loading')
          ])
        }
      });
      this.data = []
      let index = 0
      this.title === 1 ? this.pageLen = 4 : this.pageLen = 3

      if (!this.$route.params.camNum) {
        this.$router.go(-1)
      }

      if (~~this.$route.params.sectionNum) {
        console.log(this.$route.params.sectionNum);
        const question = await ajax(this.url + '/api/ieltsCategory/Question', {
          topicType: 1,
          camNum: this.$route.params.camNum,
          testNum: this.$route.params.testNum,
          section: this.$route.params.sectionNum
        })
        this.data.push(question.data)
      } else if (this.$route.params.testNum === "scripture") {
        this.$route.params.sectionNum = this.$route.params.sectionNum.toString()
        const question = await ajax(this.url + '/api/ieltsCategory/QuestionById', { id: this.$route.params.camNum })
        this.data.push(question.data)
      } else if (this.$route.params.testNum === "scripture1") {
        this.title = 3
        console.log(this.title);
        this.$route.params.sectionNum = this.$route.params.sectionNum.toString()
        const question = await ajax(this.url + '/api/ieltsCategory/QuestionById', { id: this.$route.params.camNum })
        this.data.push(question.data)
      } else {
        for (let i = 0; i < this.pageLen; i++) {
          const question = await ajax(this.url + '/api/ieltsCategory/Question', {
            topicType: this.title,
            camNum: this.$route.params.camNum,
            testNum: this.$route.params.testNum,
            section: i + 1
          })
          //
          this.data.push(question.data)

          // console.log(this.question);
          // console.log(this.data);
        }
      }               //如果是练习

      this.value.length = 40
      this.$Spin.hide();

      if (this.title === 3) {
        this.m = 59
        this.s = 59
      } else {
        this.m = 29
        this.s = 59
      }
      this.localData();
      console.log(this.data);
      let arr = [];
      let a = -1

      /*this.data.forEach((item,index)=>{   //多选题数据过滤
        item.themeDomainList.forEach((item1,index1)=>{
          item1.trunkList.forEach((item2,index2)=>{
            if(item2.serial.includes(',')){
              let temArr = []
              let serialArr = []
              let tem = item2
              let a = item2.serial.split(',')


              for(let i = 0 ; i < a.length ; i++){
                temArr.push(tem)
                temArr.serial = ...a
              }

              // console.log(temArr);
              // ...
              console.log(...a);
              console.log(...temArr);
              // a.forEach( (i,i1) => {
              //   // tem.serial = i
              //   temArr.push(tem)
              //   console.log(temArr.trunkList);
              // })
              // item1.trunkList.push(tem)
              item1.trunkList = []
              item1.trunkList = temArr

            }
          })
        })
      })*/
      console.log(this.data);
    },
    localData() {
      console.log(this.question);
      this.question = this.data[this.page - 1].themeDomainList;
    },
    inputBlue(i, s) {
      // console.log(i,s);
    },
    finish() {
      this.$Modal.confirm({
        title: '完成',
        content: '本次机考已完成，是否去核对答案',
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.$router.push({ name: 'answer', params: { answer: this.answer } });
        },
      });
    },
    answerCom() {   //填写答案标准格式化
      let val = this.value
      for (let i = 0; i < val.length; i++) {
        if (Number.isFinite(val[i])) {  //如果是数字
          switch (val[i]) {
            case 0:
              val[i] = "A"
              break
            case 1:
              val[i] = "B"
              break
            case 2:
              val[i] = "C"
              break
            case 3:
              val[i] = "D"
              break
          }
        }
        if (Array.isArray(val[i])) {
          for (let i1 = 0; i1 < val[i].length; i1++) {
            switch (val[i][i1]) {
              case 0:
                val[i][i1] = "A"
                break
              case 1:
                val[i][i1] = "B"
                break
              case 2:
                val[i][i1] = "C"
                break
              case 3:
                val[i][i1] = "D"
                break
              case 4:
                val[i][i1] = "E"
                break
              case 5:
                val[i][i1] = "F"
                break
              case 6:
                val[i][i1] = "G"
                break
              case 7:
                val[i][i1] = "H"
                break
            }
          }
          val[i] = val[i].join(',')
        }
      }
    },
    custom() {
      this.answerCom()
      console.log(this.value);
      this.$Modal.confirm({
        title: '完成',
        content: '点击确定跳转至下一单元',
        okText: '确定',
        cancelText: '返回',
        onOk: () => {
          this.selectItemIndex = ''
          switch (this.title) {
            case 1:
              this.answer.hearing = this.value
              this.value = []
              this.title = 3
              this.page = 1
              this.m = 59
              this.s = 59
              this.getData();
              this.$Message.info('阅读题开始');
              console.log(this.answer);
              break;
            case 3:
              this.answer.reading = this.value
              this.$Message.info('写作题开始');
              this.title = 4
              this.value = []
              this.page = 1
              this.m = 29
              this.s = 59
              console.log(this.answer);
              break;
          }

        },
      });
    },
    countDown() {
      let time = setInterval(() => {
        this.s--
        if (this.s === 0) {
          this.m--
          if (this.m < 10) {
            this.m = '0' + this.m
          }
          this.s = 59
        }
        if (this.m === '00') {  //考试结束
          this.s = 0
          clearInterval(time)
          this.instance('info')
        }
        if (this.s < 10) {
          this.s = '0' + this.s
        }
      }, 1000)
      // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
      this.$once('hook:beforeDestroy', () => {
        clearInterval(time);
      })
    },
    playAudio(flag = true) {
      let audio = this.$refs.audio
      this.isPlay = !this.isPlay
      if (flag) {
        audio.play()
      } else {
        audio.pause()
      }

    },
    changePage(flag) {
      this.audio = false
      flag ? this.page++ : this.page--
      this.localData()
      window.scrollTo(0, 0)
    },
    contentFilters(val, num) {
      let newVal = val.replace('[blank][/blank]', '');
      return newVal
    },
  },
}
</script>
<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
<style scoped lang="stylus">
  .ivu-card-head p{
    overflow visible!important;
    white-space normal!important;
  }
  .click
    background-color: #399fff
    .active-a
      color: #fff
  .ivu-row:last-child
    margin-bottom  67px
  /*.ivu-row:first-child*/
    /*margin-top 52px*/
  .ivu-radio-group-vertical .ivu-radio-wrapper
    height auto
  .ivu-radio-wrapper
    white-space pre-wrap
  .isPhoneDiv
    flex-direction: column
    button
      margin 10px 0
  .ivu-page-item:hover
    border: 1px solid #2d8cf0
  .ivu-page-item:hover a
    color: #2d8cf0
  .ivu-page
    margin: 20px 0;
    text-align: center
  .btn-div
    display: flex
    justify-content: flex-end
    width: 200px
  .active
    border-color #2d8cf0
    a
      color #2d8cf0
  .ivu-col-span-22
    width 100%
  .select
    display: flex
  .question-ul
    li
      margin 20px 0
      display: flex
      p
        font-size:16px
  .layout-user
    margin-left:15px
    width: 400px
    display: flex
    align-items: center
    p
      padding 0 10px
  .layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  .layout-logo{
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 15px;
  }
  .layout-header
    /*height: 60px;*/
    background: #fff;
    box-shadow: 0 1px 1px rgba(0,0,0,.1);
    display: flex
    align-items: center
    justify-content: space-between
    h1
      font-size: 18px
      padding-left:15px
      width:200px

  /*margin-top:20px*/
  .layout-copy{
    text-align: center;
    padding: 10px 0 20px;
    color: #9ea7b4;
  }
  .layout-ceiling
    background: #464c5b;
    padding: 10px 0;
    overflow: hidden;
    display: flex
    align-items: center
    justify-content: space-between
    color #9ba7b5
    font-size 14px
    .layout-time
      display: flex
      ///*margin-right: 20px*/
      span
        font-size:18px
        padding: 0 4px
        i
          font-size:16px
          font-style normal

  .layout-ceiling-main{
    float: right;
    margin-right: 15px;
    width: 200px;
    display: flex;
    justify-content: flex-end;
  }
  .layout-ceiling-main a{
    color: #9ba7b5;
  }

  @media screen and (max-width: 1920px) {
   .hearing-box{
     margin-bottom:106px;
   }
}
  @media screen and (max-width: 960px) {
   .hearing-box{
     margin-bottom:160px;
   }
}
</style>



// WEBPACK FOOTER //
// src/pages/Exercise/Exercise.vue